<template>
  <apexchart
    type="bar"
    :options="chartOptions"
    :series="updatedSeries"
    height="350"
  />
</template>

<script>
  import {
    compose,
    max,
    pathOr,
    min,
    reduce,
    converge,
    identity,
    head,
    prop,
    map,
    over,
    lensProp,
    propOr
  } from 'ramda'
  import { toFixed } from '../../../utils/ramda-utils'
  import { BLUE, GREEN, RED, YELLOW } from '../../../constants/charts'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      labels: {
        type: Array,
        default: () => ['Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
      series: {
        type: Array,
        default: () => [
          {"name":"not_active","data":[11,12,3,2,4]},
          {"name":"1_4_days","data":[2,1,3,2,4]},
          {"name":"5_5_days","data":[0,0,5,3,7]},
          {"name":"6_7_days","data":[0,6,3,6,2]}
        ]
      },
    },
    computed: {
      updatedSeries(){
        return compose(
          map(over(lensProp('name'), (name) => this.$t(`charts.${name}`))),
          propOr([], 'series')
        )(this)
      },
      dataSeries: pathOr([], ['series', 0, 'data']),
      maxValue: compose(
        converge(
          reduce(max),
          [
            head,
            identity
          ]
        ),
        prop('dataSeries')
      ),
      minValue: compose(
        converge(
          reduce(min),
          [
            head,
            identity
          ]
        ),
        prop('dataSeries')
      ),
      chartOptions() {
        return {
          chart: {
            animations: {
              enabled: true,
            },
            type: 'bar',
            stacked: true,
            stackType: '100%',
            toolbar:{
              show: false,
            }
          },
          formatter: function (val, opts) {
            return val
          },
          xaxis: {
            type: 'category',
            categories: this.labels,
            labels: {
              show: true,
            }
          },
          yaxis: {
            labels: { formatter: toFixed(0) },
            tickAmount: this.numberOfTicks,
          },
          title: {
            text: this.$t('charts.percentage'),
          },
          colors: [ RED, YELLOW, GREEN, BLUE ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '8px',
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (value) => {
                const label = value === 1 ? 'student' : 'students'
                return `${value} ${this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, label))}`
              }
            }
          },
          states: {
            hover: {
              filter: {
                type: 'none'
              }
            }
          },
          legend: {
            position: 'right',
            offsetX: 0,
            offsetY: 50
          },
        }
      },
      ...mapGetters('organization', ['currentOrganizationType'])
    }

  }
</script>

<style lang="scss" scoped>

</style>
